<div class="speech-bubble__icon">
    <app-svg-icon
        class="icon"
        [src]="'logo_symbol.svg'"
        [svgStyle]="{ 'width.px': '45', 'height.px': '51' }"
    ></app-svg-icon>
</div>
<div class="speech-bubble__text header-title">{{text}}</div>
